import type {
  CenterProps,
  LoaderProps as MantineLoaderProps,
} from '@mantine/core';
import { Center, Loader as MantineLoader } from '@mantine/core';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';

export interface LoaderProps extends CenterProps {
  loaderProps?: MantineLoaderProps;
  variant?: 'full-height' | 'full-screen' | 'viewport';
}

const Loader = ({ loaderProps, variant, ...rest }: LoaderProps) => {
  const theme = useTheme();

  const centerProps: CenterProps = useMemo(() => {
    if (variant === 'full-height') {
      return { h: '100vh', w: '100%' };
    }
    if (variant === 'full-screen') {
      return { h: '100vh', w: '100vw' };
    }
    if (variant === 'viewport') {
      return { h: '100%', w: '100%' };
    }

    return {};
  }, [variant]);

  if (!variant) {
    return (
      <MantineLoader color={theme.palette.primary.main} {...loaderProps} />
    );
  }

  return (
    <Center {...centerProps} {...rest}>
      <MantineLoader
        color={theme.palette.primary.main}
        data-testid="loader"
        {...loaderProps}
      />
    </Center>
  );
};

export default Loader;
